import request from '@/utils/request'

/**
 * 发票抬头管理接口。
 */

// 查询当前用户的全部发票抬头
export const queryInvoiceTitleList = () => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/invoiceTitle/list',
		method: 'get',
		isShowLoader: false,
		headers: {
			isToken: true
		}
	})
}

// 新增或编辑发票抬头
export const saveInvoiceTitle = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/invoiceTitle/saveOrUpdate',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 设置默认发票抬头
export const setDefaultInvoiceTitle = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/invoiceTitle/setDefault',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}

// 删除发票抬头
export const deleteInvoiceTitle = data => {
	return request({
		url: process.env.VUE_APP_PREFIX_API_MEMBERSERVER + '/api/invoiceTitle/delete',
		method: 'post',
		isShowLoader: false,
		headers: {
			isToken: true
		},
		data
	})
}
